import React, { useState, useEffect } from 'react';

const BookForm = ({ initialData, authors, categories, onSubmit, onCancel, onAddAuthor, onAddCategory, loading }) => {
  const [formData, setFormData] = useState({
    title: '',
    title_ky: '',
    description: '',
    description_ky: '',
    cover: null,
    file: null,
    authors: [],
    categories: [],
    isbn: '',
    publisher: '',
    publish_year: '',
    pages: '',
    language: 'ru',
    file_format: 'pdf',
    is_featured: false,
    is_published: true
  });

  useEffect(() => {
    if (initialData) {
      setFormData({
        title: initialData.title || '',
        title_ky: initialData.title_ky || '',
        description: initialData.description || '',
        description_ky: initialData.description_ky || '',
        cover: null,
        file: null,
        authors: initialData.authors?.map(a => a.id) || [],
        categories: initialData.categories?.map(c => c.id) || [],
        isbn: initialData.isbn || '',
        publisher: initialData.publisher || '',
        publish_year: initialData.publish_year || '',
        pages: initialData.pages || '',
        language: initialData.language || 'ru',
        file_format: initialData.file_format || 'pdf',
        is_featured: initialData.is_featured || false,
        is_published: initialData.is_published || true
      });
    }
  }, [initialData]);

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    if (type === 'checkbox') {
      setFormData(prev => ({ ...prev, [name]: checked }));
    } else if (type === 'file') {
      setFormData(prev => ({ ...prev, [name]: files[0] }));
    } else {
        setFormData(prev => ({ 
            ...prev, 
            [name]: value
        }));
    }
  };

  const handleMultiSelect = (e, field) => {
    const values = Array.from(e.target.selectedOptions, option => Number(option.value));
    setFormData(prev => ({ ...prev, [field]: values }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <form onSubmit={handleSubmit} className="admin-form">
      <div className="form-row">
        <div className="form-group full-width">
          <label>Название книги *</label>
          <input
            type="text"
            name="title"
            value={formData.title}
            onChange={handleChange}
            required
            placeholder="Русский"
          />
           <input
            type="text"
            name="title_ky"
            value={formData.title_ky}
            onChange={handleChange}
            placeholder="Кыргызча"
            style={{ marginTop: '8px' }}
          />
        </div>
      </div>

      <div className="form-row">
        <div className="form-group full-width">
          <label>Описание *</label>
          <textarea
            name="description"
            value={formData.description}
            onChange={handleChange}
            rows="6"
            required
            placeholder="Русский"
          />
           <textarea
            name="description_ky"
            value={formData.description_ky}
            onChange={handleChange}
            rows="6"
            placeholder="Кыргызча"
            style={{ marginTop: '8px' }}
          />
        </div>
      </div>

      <div className="form-row">
        <div className="form-group">
          <label>Авторы</label>
          <select
            multiple
            value={formData.authors}
            onChange={(e) => handleMultiSelect(e, 'authors')}
            size="4"
          >
            {authors.map(author => (
              <option key={author.id} value={author.id}>
                {author.full_name || `${author.last_name} ${author.first_name}`}
              </option>
            ))}
          </select>
          <small>Удерживайте Ctrl/Cmd для выбора нескольких</small>
          <button type="button" className="link-button" onClick={onAddAuthor}>
            + Добавить автора
          </button>
        </div>

        <div className="form-group">
          <label>Категории</label>
          <select
            multiple
            value={formData.categories}
            onChange={(e) => handleMultiSelect(e, 'categories')}
            size="4"
          >
            {Array.isArray(categories) && categories.map(cat => (
              <option key={cat.id} value={cat.id}>{cat.name}</option>
            ))}
          </select>
          <small>Удерживайте Ctrl/Cmd для выбора нескольких</small>
          <button type="button" className="link-button" onClick={onAddCategory}>
            + Добавить категорию
          </button>
        </div>
      </div>

      <div className="form-row">
        <div className="form-group">
          <label>ISBN</label>
          <input
            type="text"
            name="isbn"
            value={formData.isbn}
            onChange={handleChange}
          />
        </div>

        <div className="form-group">
          <label>Издательство</label>
          <input
            type="text"
            name="publisher"
            value={formData.publisher}
            onChange={handleChange}
          />
        </div>
      </div>

      <div className="form-row">
        <div className="form-group">
          <label>Год издания</label>
          <input
            type="number"
            name="publish_year"
            value={formData.publish_year}
            onChange={handleChange}
            min="1000"
            max="2100"
          />
        </div>

        <div className="form-group">
          <label>Количество страниц</label>
          <input
            type="number"
            name="pages"
            value={formData.pages}
            onChange={handleChange}
            min="1"
          />
        </div>

        <div className="form-group">
          <label>Язык</label>
          <select
            name="language"
            value={formData.language}
            onChange={handleChange}
          >
            <option value="ru">Русский</option>
            <option value="en">English</option>
            <option value="ky">Кыргызча</option>
            <option value="kz">Қазақша</option>
            <option value="other">Другой</option>
          </select>
        </div>

        <div className="form-group">
          <label>Формат файла</label>
          <select
            name="file_format"
            value={formData.file_format}
            onChange={handleChange}
          >
            <option value="pdf">PDF</option>
            <option value="epub">EPUB</option>
            <option value="fb2">FB2</option>
            <option value="mobi">MOBI</option>
            <option value="txt">TXT</option>
            <option value="doc">DOC/DOCX</option>
            <option value="other">Другой</option>
          </select>
        </div>
      </div>

      <div className="form-row">
        <div className="form-group">
          <label>Обложка</label>
          <input
            type="file"
            name="cover"
            accept="image/*"
            onChange={handleChange}
          />
        </div>

        <div className="form-group">
          <label>Файл книги</label>
          <input
            type="file"
            name="file"
            accept=".pdf,.epub,.fb2,.mobi,.txt,.doc,.docx"
            onChange={handleChange}
          />
        </div>
      </div>

      <div className="form-row">
        <div className="form-group checkbox-group">
          <label>
            <input
              type="checkbox"
              name="is_featured"
              checked={formData.is_featured}
              onChange={handleChange}
            />
            Рекомендуемая книга
          </label>
        </div>

        <div className="form-group checkbox-group">
          <label>
            <input
              type="checkbox"
              name="is_published"
              checked={formData.is_published}
              onChange={handleChange}
            />
            Опубликована
          </label>
        </div>
      </div>

      <div className="form-actions">
        <button type="submit" className="submit-button" disabled={loading}>
          {loading ? 'Сохранение...' : (initialData ? 'Обновить книгу' : 'Добавить книгу')}
        </button>
        <button type="button" className="cancel-button" onClick={onCancel}>
          Отмена
        </button>
      </div>
    </form>
  );
};

export default BookForm;
